import { render, staticRenderFns } from "./MirabiliteDates.vue?vue&type=template&id=512e9235&scoped=true&"
import script from "./MirabiliteDates.vue?vue&type=script&lang=js&"
export * from "./MirabiliteDates.vue?vue&type=script&lang=js&"
import style0 from "./MirabiliteDates.vue?vue&type=style&index=0&id=512e9235&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e9235",
  null
  
)

export default component.exports